import EventTile from './event-tile'
export default EventTile
